import { render, staticRenderFns } from "./customMaintenanceHistory.vue?vue&type=template&id=5a83ef6c&scoped=true&"
import script from "./customMaintenanceHistory.vue?vue&type=script&lang=js&"
export * from "./customMaintenanceHistory.vue?vue&type=script&lang=js&"
import style0 from "./customMaintenanceHistory.vue?vue&type=style&index=0&id=5a83ef6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83ef6c",
  null
  
)

export default component.exports